export default "__VITE_PUBLIC_ASSET__c1ccee25__"